import { render } from "./olvidoPass.vue?vue&type=template&id=5bc41038&scoped=true"
import script from "./olvidoPass.vue?vue&type=script&lang=js"
export * from "./olvidoPass.vue?vue&type=script&lang=js"

import "./olvidoPass.vue?vue&type=style&index=0&id=5bc41038&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bc41038"

export default script